
import Vue from 'vue';

export default Vue.component('QAlert', {
    props: {
        message: {
            type: String,
            required: true,
        },
    },
})
